export default __webpack_public_path__ + "static/media/ERA.c9d0ba27.jpg";